import {merge, isUndefined, isEmpty, has} from 'lodash';
import {createUUID, getCache, setCache} from '@nl/neu';
import Logger from '@nl/logger';
import {
	UPDATE_USER_INFO,
	APISERVICE_INITIALIZED,
	LANGUAGE_CHANGED,
	HIDE_SCORE_CHANGED,
} from '../constants';

const processUserInfo = (action) => {
	const {dtc, tve, nba, opin} = action.user;
	if (dtc.loggedIn) {
		dtc.userStatus = dtc.subs ? 'authorized' : 'authenticated';
	} else {
		dtc.subs = null;
		dtc.userStatus = 'anonymous';
	}
	if (tve.loggedIn) {
		tve.userStatus = tve.preauthorizedResourceIds && tve.preauthorizedResourceIds.length > 0 ? 'authorized' : 'authenticated';
	} else {
		tve.preauthorizedResourceIds = null;
		tve.userStatus = 'anonymous';
	}
	return {dtc, tve, nba, opin};
};

const isLoggedIn = (action) => {
	const loggedIn = !!action.user.tve.loggedIn || !!action.user.dtc.loggedIn;
	return loggedIn;
};

const isShowSignIn = (action) => {
	const loggedIn = !!action.user.tve.loggedIn || !!action.user.dtc.loggedIn
			|| !!action.user.nba.loggedIn || !!action.user.opin.loggedIn;
	return loggedIn;
};

const isShowOpinCiamSignIn = (action) => {
	const loggedIn = !!action.user.dtc.loggedIn || !!action.user.nba.loggedIn
			|| !!action.user.opin.loggedIn;
	return loggedIn;
};

const hasPs = (user, loggedIn) => {
	let ret = false;
	if (window.ps && loggedIn) {
		if (user.dtc.userStatus !== 'anonymous' || user.tve.userStatus === 'authorized') {
			ret = true;
		}
	}
	return ret;
};

const getSid = (state) => {
	if (has(state, 'data.sid')) {
		return state.data.sid;
	}
	// Get device id
	let sid = getCache('sid', 'localStorage');
	if (isUndefined(sid) || isEmpty(sid)) {
		sid = createUUID();
		setCache('sid', sid, -1, 'localStorage');
	}
	return sid;
};

const getTrackParam = (action) => {
	let userType = 'anonymous';
	let trackUsername = null;
	let trackUserId = null;
	if (action.user.tve.loggedIn) {
		userType = 'mvpdsubscriber';
	}

	if (action.user.dtc.loggedIn) {
		trackUsername = action.user.dtc.metadata.trackUsername;
		trackUserId = action.user.dtc.metadata.trackUserId;
		if (action.user.dtc.subs && action.user.dtc.subs.length > 0) {
			userType = 'subscriber';
		} else {
			userType = 'member';
		}

		if (action.user.dtc.metadata.hasFreeTrial) {
			userType = 'trialsubscriber';
		} else if (action.user.dtc.metadata.isVIP) {
			userType = 'vipuser';
		}
	}

	const ret = {userType, trackUserId, trackUsername};

	if (action.user.tve.loggedIn && !action.user.dtc.loggedIn) {
		ret.mvpduserid = action.user.dtc.uid;
	} else {
		ret.mvpduserid = null;
	}

	return ret;
};

const client = (state = {}, action, baseState = {}) => {
	switch (action.type) {
		case UPDATE_USER_INFO: {
			const {data: {user, ...otherData}, ...otherClientData} = state;
			if (has(action, 'user') && has(action.user, 'isFreePreview')) {
				const ret = merge({}, otherClientData, {
					data: merge({}, otherData, {
						user,
						isFreePreview: action.user.isFreePreview,
					}),
				});
				return ret;
			}
			const {dtc, tve, nba, opin} = processUserInfo(action);
			const loggedIn = isLoggedIn(action);
			const trackerParam = getTrackParam(action);
			const ret = merge({}, otherClientData, {
				data: merge({}, otherData, {
					user: {dtc, tve: {...tve}, nba, opin},
					isLoggedIn: loggedIn,
					isUserLoggedIn: isShowSignIn(action),
					isOpinCiamLoggedIn: isShowOpinCiamSignIn(action),
					hasPs: hasPs({dtc, tve}, loggedIn),
					uid: dtc.uid,
					sid: getSid(state),
					...trackerParam,
				}),
			});
			Logger.info(ret);
			return ret;
		}
		case APISERVICE_INITIALIZED:
			if (state.isInitialized) {
				return state;
			}
			return merge({}, state, {
				initialized: action.isInitialized,
			});
		case LANGUAGE_CHANGED: {
			const {data: {locale, ...otherData}, ...otherClientData} = state;
			const ret = merge({}, otherClientData, {
				data: merge({}, otherData, {
					locale: action.locale,
				}),
			});
			return ret;
		}
		case HIDE_SCORE_CHANGED: {
			const {data: {nlhidescore, ...otherData}, ...otherClientData} = state;
			const ret = merge({}, otherClientData, {
				data: merge({}, otherData, {
					nlhidescores: action.hideScore,
				}),
			});
			return ret;
		}
		default:
			return {...state, ...baseState, isExtend: true};
	}
};

export default client;
